import templateOnly from "@ember/component/template-only";
import { setComponentTemplate } from "@ember/component";
import { precompileTemplate } from "@ember/template-compilation";
import { svgJar } from '@cardstack/boxel/utils/svg-jar';
import '@cardstack/boxel/styles/global.css';
import './index.css';
const Infobox = setComponentTemplate(precompileTemplate(`
  <div class="boxel-infobox" ...attributes>
    <div class="boxel-infobox__text-container">
      <h2 class="boxel-infobox__title">{{@title}}</h2>
      <p class="boxel-infobox__description">{{@description}}</p>
    </div>
    <button
      class="boxel-infobox__close-button"
      type="button"
      aria-label="Close"
    >
      {{svgJar "close" width="100%" height="100%" aria-hidden=true}}
    </button>
  </div>
`, {
  strictMode: true,
  scope: () => ({
    svgJar
  })
}), templateOnly("index", "Infobox"));
export default Infobox;